import * as yup from 'yup';

export const englishAuctionSchema = yup.object().shape({
  amount: yup
    .string()
    .test({
      name: 'amount',
      test: (value, context) => {
        const reservePrice = context.options.context?.reservePrice;
        const bestBidForListing = context.options.context?.bestBidForListing;
        const balance = context.options.context?.balance;

        if (!value) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Required'
          });
        }

        if (+value < +reservePrice) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Each bid must be at least as big as the reserve amount'
          });
        }

        const nextAvailableBid = +bestBidForListing + +bestBidForListing * 0.01;

        if (+value < +nextAvailableBid) {
          return context.createError({
            type: 'CUSTOM',
            message: `New bid must be equal or greater than ${nextAvailableBid}`
          });
        }

        if (+value > +balance) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Insufficient balance'
          });
        }

        return true;
      }
    })
    .required(),
  token: yup
    .object()
    .shape({
      contractAddress: yup.string().required(),
      name: yup.string().required(),
      symbol: yup.string().required(),
      decimals: yup.number().required()
    })
    .required()
});
